import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TuiButton, TuiButtonX } from '@taiga-ui/core';

@Component({
  selector: 'pxc-image-overlay',
  imports: [TuiButton, TuiButtonX],
  host: {
    class: 'group relative block size-full aspect-square overflow-hidden rounded-sm object-cover',
  },
  templateUrl: './image-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageOverlayComponent {
  @Input() caption: string;

  @Input() showDelete = true;

  @Output() delete = new EventEmitter<void>();
}
